module.exports = __webpack_public_path__ + "img/app-demo-image.09f0066b.png";